import {
  NoteStateMapV510,
  NoteStateV510,
} from 'src/common/store/migrate/types/5.1.0';
import { NotebookState } from 'src/common/store/notebook/NotebookState';
import { safelyGet } from 'src/common/utils/safelyGet';
import { InitialData } from 'src/types';

export default (data: InitialData) => {
  const oldNotebook: Partial<NotebookState> = safelyGet(data, ['notebook'], {});
  const oldNotes: NoteStateMapV510 = safelyGet(oldNotebook, ['notes'], {});
  const newNotes: NoteStateMapV510 = Object.entries(oldNotes).reduce(
    (acc, [noteId, note]) => {
      // @ts-ignore: migrating namedGraph string to namedGraphs string[]
      const namedGraphs = note.editorSettings.namedGraph
        ? [
            // @ts-ignore: migrating namedGraph string to namedGraphs string[]
            note.editorSettings.namedGraph,
          ]
        : [];
      const newNote: NoteStateV510 = {
        ...note,
        editorSettings: {
          ...note.editorSettings,
          namedGraphs,
        },
      };
      acc[noteId] = newNote;
      return acc;
    },
    {}
  );
  return {
    ...data,
    version: '1.15.0',
    notebook: {
      ...oldNotebook,
      notes: newNotes,
    },
  };
};
